(() => {
  if (customElements.get('audrey-dispatch-date')) return;
  class AudreyDispatchDate extends HTMLElement {
    connectedCallback() {
      this.refresh = () => this.updateDate();
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('focus', this.refresh);
      this.updateDate();
    }
    disconnectedCallback() {
      clearTimeout(this.midnightTimer);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('focus', this.refresh);
    }
    updateDate() {
      clearTimeout(this.midnightTimer);
      const now = new Date();
      this.textContent = this.formatDeadline(now);
      // Recalculate when the customer's local calendar day changes, including DST.
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      this.midnightTimer = setTimeout(() => this.updateDate(), midnight.getTime() - now.getTime() + 100);
    }
    formatDeadline(now) {
      // Browser-local calendar: the next weekday, never the current day.
      const deadline = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 12);
      while (deadline.getDay() === 0 || deadline.getDay() === 6) {
        deadline.setDate(deadline.getDate() + 1);
      }
      return new Intl.DateTimeFormat('en-CA', {
        weekday: 'short', month: 'short', day: 'numeric'
      }).format(deadline);
    }
  }
  customElements.define('audrey-dispatch-date', AudreyDispatchDate);
})();
